import { render, staticRenderFns } from "./shopChargeOrder.vue?vue&type=template&id=a52c0024&scoped=true&"
import script from "./shopChargeOrder.vue?vue&type=script&lang=js&"
export * from "./shopChargeOrder.vue?vue&type=script&lang=js&"
import style0 from "./shopChargeOrder.vue?vue&type=style&index=0&id=a52c0024&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c0024",
  null
  
)

export default component.exports